var map = {
	"./AD.png": "lrXL",
	"./AE.png": "Rs7B",
	"./AF.png": "edEu",
	"./AG.png": "1GXI",
	"./AI.png": "hwHc",
	"./AL.png": "Og7M",
	"./AM.png": "oxXk",
	"./AO.png": "t2a5",
	"./AR.png": "nRmv",
	"./AS.png": "/7HH",
	"./AT.png": "8ZCs",
	"./AU.png": "Ptc+",
	"./AW.png": "MXs7",
	"./AX.png": "QYEx",
	"./AZ.png": "/mcF",
	"./BA.png": "ipBf",
	"./BB.png": "WTxP",
	"./BD.png": "Odrz",
	"./BE.png": "KQFK",
	"./BF.png": "FK6t",
	"./BG.png": "RmqW",
	"./BH.png": "5WrJ",
	"./BI.png": "o9wG",
	"./BJ.png": "iGIV",
	"./BM.png": "qJ5z",
	"./BN.png": "ntX2",
	"./BO.png": "ODm0",
	"./BR.png": "ssuS",
	"./BS.png": "OuEB",
	"./BT.png": "S9AU",
	"./BW.png": "car5",
	"./BY.png": "MPRN",
	"./BZ.png": "enxt",
	"./CA.png": "rpeJ",
	"./CC.png": "4h2Y",
	"./CD.png": "+b3z",
	"./CF.png": "nTtV",
	"./CG.png": "pBSd",
	"./CH.png": "p5z1",
	"./CI.png": "tUBc",
	"./CK.png": "FZ9I",
	"./CL.png": "jZkO",
	"./CM.png": "cV2x",
	"./CN.png": "gnOi",
	"./CO.png": "qZEX",
	"./CR.png": "8ufJ",
	"./CU.png": "iAgy",
	"./CV.png": "FLuC",
	"./CW.png": "DQpN",
	"./CX.png": "jd+5",
	"./CY.png": "uxcK",
	"./CZ.png": "HSnI",
	"./DE.png": "vOHp",
	"./DJ.png": "hvjA",
	"./DK.png": "xWBP",
	"./DM.png": "cU/w",
	"./DO.png": "8Bs7",
	"./DZ.png": "d6Yf",
	"./EC.png": "tcvt",
	"./EE.png": "iViS",
	"./EG.png": "c+oS",
	"./EH.png": "bZBX",
	"./EN.png": "WK/v",
	"./ER.png": "GzBz",
	"./ES.png": "t+ah",
	"./ET.png": "uSIr",
	"./FI.png": "mAVX",
	"./FJ.png": "WuRE",
	"./FK.png": "CHOf",
	"./FM.png": "gy/w",
	"./FO.png": "J2yr",
	"./FR.png": "u/XX",
	"./GA.png": "ykYi",
	"./GB-SCT.png": "Nk6G",
	"./GB.png": "PEZk",
	"./GD.png": "iwof",
	"./GE.png": "OPwv",
	"./GG.png": "TWIt",
	"./GH.png": "ivXc",
	"./GI.png": "Hbg3",
	"./GL.png": "AKSb",
	"./GM.png": "zj/a",
	"./GN.png": "IFOu",
	"./GQ.png": "Bq2y",
	"./GR.png": "xBU9",
	"./GT.png": "U3jr",
	"./GU.png": "Jl6v",
	"./GW.png": "vKvb",
	"./GY.png": "R0wU",
	"./HI.png": "fGNI",
	"./HK.png": "H730",
	"./HN.png": "19rR",
	"./HR.png": "XZvY",
	"./HT.png": "E+Js",
	"./HU.png": "Er8E",
	"./ID.png": "/Fyj",
	"./IE.png": "Aq7y",
	"./IL.png": "TRf8",
	"./IM.png": "nzir",
	"./IN.png": "+vIC",
	"./IO.png": "Hyev",
	"./IQ.png": "MR8g",
	"./IR.png": "2iaK",
	"./IS.png": "vBRr",
	"./IT.png": "zdZM",
	"./JE.png": "5zap",
	"./JM.png": "QmD1",
	"./JO.png": "mblU",
	"./JP.png": "GHwX",
	"./KE.png": "rDvs",
	"./KG.png": "B3MY",
	"./KH.png": "JM0e",
	"./KI.png": "zVSd",
	"./KM.png": "SQyZ",
	"./KN.png": "5mSg",
	"./KP.png": "Aprs",
	"./KR.png": "kqQq",
	"./KW.png": "Ycdw",
	"./KY.png": "o8aP",
	"./KZ.png": "4UPb",
	"./LA.png": "PVAq",
	"./LB.png": "bjUj",
	"./LC.png": "Zsdb",
	"./LI.png": "pqr7",
	"./LK.png": "PWwJ",
	"./LR.png": "93cd",
	"./LS.png": "clcJ",
	"./LT.png": "8CCz",
	"./LU.png": "DRqY",
	"./LV.png": "+Gvf",
	"./LY.png": "ad2A",
	"./MA.png": "Y3PK",
	"./MC.png": "kDDU",
	"./MD.png": "XgsD",
	"./ME.png": "PB/c",
	"./MG.png": "8O8X",
	"./MH.png": "/zZo",
	"./MK.png": "NstB",
	"./ML.png": "5Zlg",
	"./MM.png": "enR3",
	"./MN.png": "70Ik",
	"./MO.png": "Qojm",
	"./MP.png": "rXMK",
	"./MR.png": "o3tO",
	"./MT.png": "x+lM",
	"./MU.png": "O+kC",
	"./MV.png": "vPLz",
	"./MW.png": "Pi+2",
	"./MX.png": "HIK+",
	"./MY.png": "vhmJ",
	"./MZ.png": "uQ7x",
	"./NA.png": "2+hf",
	"./NE.png": "FyhB",
	"./NF.png": "ZPW+",
	"./NG.png": "rQsV",
	"./NI.png": "1/YB",
	"./NL.png": "/vwG",
	"./NO.png": "SWX0",
	"./NP.png": "NVa8",
	"./NR.png": "7PAl",
	"./NU.png": "1b3p",
	"./NZ.png": "V1vc",
	"./OM.png": "oKxp",
	"./PA.png": "tJ7C",
	"./PE.png": "hUnv",
	"./PF.png": "zilT",
	"./PG.png": "tiZ6",
	"./PH.png": "Y/vN",
	"./PK.png": "/MwN",
	"./PL.png": "ZR8k",
	"./PN.png": "S5xf",
	"./PR.png": "8vyy",
	"./PS.png": "+Iyj",
	"./PT.png": "v+wv",
	"./PW.png": "CM50",
	"./PY.png": "MShN",
	"./QA.png": "1e9C",
	"./RO.png": "qTLh",
	"./RS.png": "VMKl",
	"./RU.png": "D3Vl",
	"./RW.png": "FKo/",
	"./SA.png": "Etqa",
	"./SB.png": "UQxv",
	"./SC.png": "/Dec",
	"./SD.png": "GNgn",
	"./SE.png": "7JQg",
	"./SG.png": "Qt7g",
	"./SI.png": "6K/y",
	"./SK.png": "HHsy",
	"./SL.png": "X8tl",
	"./SM.png": "DU8c",
	"./SN.png": "Szvn",
	"./SO.png": "c+Um",
	"./SR.png": "avRG",
	"./SS.png": "XnCo",
	"./ST.png": "QXmt",
	"./SV.png": "L7qt",
	"./SX.png": "JZ8F",
	"./SY.png": "RY8Z",
	"./SZ.png": "t2Dp",
	"./TC.png": "PVwb",
	"./TD.png": "kuEn",
	"./TG.png": "2mH5",
	"./TH.png": "XeEM",
	"./TJ.png": "AXud",
	"./TK.png": "zImJ",
	"./TL.png": "JNID",
	"./TM.png": "VWr3",
	"./TN.png": "BGH8",
	"./TO.png": "t8pw",
	"./TR.png": "O6DP",
	"./TT.png": "aBhy",
	"./TV.png": "neJg",
	"./TW.png": "RNYg",
	"./TZ.png": "+Peq",
	"./UA.png": "sxYX",
	"./UG.png": "6Riq",
	"./US.png": "cxhZ",
	"./UY.png": "3tFQ",
	"./UZ.png": "eH7V",
	"./VA.png": "5rZY",
	"./VC.png": "KNYu",
	"./VE.png": "Dfzh",
	"./VG.png": "3Fok",
	"./VI.png": "6pd2",
	"./VN.png": "EjDI",
	"./VU.png": "5eJS",
	"./WS.png": "wyW/",
	"./Wales.png": "hVRf",
	"./World.png": "exue",
	"./XK.png": "1RWy",
	"./YE.png": "2ORY",
	"./ZA.png": "ekmz",
	"./ZM.png": "LzFL",
	"./ZW.png": "kQUF"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5osc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/countries ^\.\/.*\.png$
// module id = 5osc
// module chunks = 2